export default {
    AMOUNT_FORMAT_PROPS: {
        style: 'currency',
    },
    AMOUNT_PERCENTAGE_FORMAT_PROPS: {
        style: 'percent',
        minimumFractionDigits: 2,
    },
};
//# sourceMappingURL=miscellaneous-currency.constants.js.map